const IDS_Usuarios = {
  Aline_Galimidi: {
    id_usuario: "5e0f291670edaf00137fcffd",
  },
  Nicolas_Perez: {
    id_usuario: "611bebffadd7fa00257b0b59",
  },
  Juan_Jose_Ramos: {
    id_usuario: "5e0f291a70edaf00137fd297",
  },
  Luis_Recabarren: {
    id_usuario: "5e0f291a70edaf00137fd2f5",
  },
  Marcelo_Baladron: {
    id_usuario: "657288001299d8001250f6b6",
  },
  Eileen_Perez: {
    id_usuario: "64ac1bd5d1439e0021b2d3ee",
  },
  Sebastian_Poblete: {
    id_usuario: "664829149d24f10012fd4d05",
  },
  Paul_Salazar: {
    id_usuario: "6657fb1aab835b00115961c4",
  },
  Fabian_Salazar: {
    id_usuario: "6157cc68ee840e00110a6243",
  },
  Sergio_Silvestre: {
    id_usuario: "5e0f291b70edaf00137fd4a8",
  },
  Dayana_Garcia: {
    id_usuario: "68bbb321c960b905ef7de901",
  },
  Rodrigo_Gonzalez: {
    id_usuario: "6965b6a681fc1944878d2db7",
  },
  Cristobal_Jessen: {
    id_usuario: "5e0f291770edaf00137fd089",
  },
};

export const USUARIO_COMPRAS_MENORES = IDS_Usuarios.Rodrigo_Gonzalez.id_usuario; // Reemplazo vacaciones de Rodrigo Gonzalez - 06.02.2026
export const APROBADOR_GERENTE_GAF = IDS_Usuarios.Marcelo_Baladron.id_usuario; // Reemplazo vacaciones de Marcelo - 02.02.2026
export const USUARIO_MANTENCIONES_VEHICULARES_ANTOFAGASTA = IDS_Usuarios.Fabian_Salazar.id_usuario;

export const PAIS_CHILE = "6645287f93aafbf0e42a0c11";
export const PAIS_PERU = "6645288793aafbf0e42a0c14";
export const GERENCIA_PERU = "655615b5b6eb2a0011438b4e";